/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { DigitalAssistantFeedbackTypes } from './FeedbackType';
import pearlApi from '../../api/pearlApi';
import { FeedbackAttachment } from './FeedbackForm';

export type postDocumentVersionOrFeedbackProps = {
  documentVersionId?: string;
  content: string;
};

export async function postDocumentVersionComment(documentVersionId: string, content: string) {
  let data = {
    data: {
      content: content.trim(),
    },
  };
  await pearlApi.post(`/documentVersions/${documentVersionId}/comments`, data);
}
export async function postFeedback(
  content: string,
  feedbackType: DigitalAssistantFeedbackTypes,
  attachments?: FeedbackAttachment[],
  documentVersionId?: string | undefined
) {
  let data = {
    data: {
      feedback_type: feedbackType,
      content: content.trim(),
      doc_version_id: documentVersionId,
      attachments: attachments,
    },
  };
  const response = pearlApi.post(`/feedbacks`, data);
  return response;
}
